import React, { type HTMLAttributes, type ReactNode } from 'react';
import * as css from './Note.module.scss';
import cn from 'clsx';

export interface NoteProps extends HTMLAttributes<HTMLDivElement> {
    symbol?: string;
    children: NonNullable<ReactNode>;
}

export function Note({ symbol, children, className, ...props }: NoteProps) {
    return (
        <div {...props} className={cn(css.root, className)}>
            {symbol ? <div children={symbol} className={css.symbol} /> : null}
            <div children={children} className={css.text} />
        </div>
    );
}
